import React, { useEffect } from "react";

import { Box, TextField } from "@mui/material";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import DOMPurify from "dompurify";

import "../../pages/admin/StudySetup/Questionnaire/FormBuilder/QuestionnaireCss.css";
import { useGetRule } from "../../hooks/useRules";
import { checkRuleValue } from "../helpers/helper";
import { useAlignment } from "../../context/alignmentFormbuilder/AlignmentContext";

const AgeRangeYear = React.forwardRef((props, ref) => {
  const {
    name,
    defaultValue,
    hide,
    labelAlignment,
    disabled,
    border,
    borderTop,
    borderBottom,
    borderSides,
    currentPage,
    label,
  } = props;

  const { Rules, triggerUpdate } = useGetRule();
  const { alignment } = useAlignment();
  const [openModal, setOpenModal] = React.useState(false);
  const [titleName, setTitleName] = React.useState("");
  const [showTitle, setShowTitle] = React.useState(false);
  const [isDisabled, setDisabled] = React.useState(disabled);
  const [isVisible, setVisible] = React.useState(true);
  const [value, setValue] = React.useState();


  const {
    textSize, 
    width: customWidth,
    MaxValue, 
    MinValue,
    subLabel
  } = props.data;

  useEffect(() => {
    const { form, formResponse } = Rules;
    if (formResponse) {
      const myId = props?.data.id;
      if (
        (form[myId] && form[myId]["dependsOn"]) ||
        (form[myId] && form[myId]["useCalculation"])
      ) {
        const ruleData = checkRuleValue(form[myId], formResponse);
        const { isVisible, isDisabled } = ruleData;
        setVisible(isVisible);
        setDisabled(isDisabled);
      }
    }
  }, [Rules]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  

  const handleShowTitle = () => {
    if (titleName === "") {
      setShowTitle(false);
    } else {
      setShowTitle(true);
    }
  };

  const changeYear = (event) => {
    event.preventDefault();
    const inputValue = parseInt(event.target.value, 10);
  
    // Check if MinValue and MaxValue are provided
    if (MinValue && MaxValue) {
      if (inputValue >= MinValue && inputValue <= MaxValue) {
        setValue(inputValue);
        if (props?.set) {
          props?.set({ key: props.data.id, value: inputValue });
        }
      } else {
        setValue("");
        if (props?.set) {
          props?.set({ key: props.data.id, value: "" });
        }
        console.warn(`Value must be between ${MinValue} and ${MaxValue}`);
      }
    } else {
      // If MinValue and MaxValue are not provided, accept any value
      setValue(inputValue);
      if (props?.set) {
        props?.set({ key: props.data.id, value: inputValue });
      }
    }
  
    triggerUpdate(true);
  };
  
  

  const handleTitleName = (event) => {
    event.preventDefault();
    setTitleName(event.target.value);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "none !important",
    boxShadow: 24,
    borderRadius: "3px",
    p: 3,
  };

  const sanitizedLabel = DOMPurify.sanitize(label || "");


  return (
    <>
      {" "}
      {isVisible && (
        <div
          className={`${border ? "borderFullRadius " : ""} ${
            borderTop ? "borderTop " : ""
          } ${borderSides ? "borderSides " : ""} ${
            borderBottom ? "borderBottom " : ""
          } flexCenter`}
        >
          {currentPage && (
            <div className="currentPage">
              {/* Page <p>{currentPage}</p> */}
              {!showTitle ? (
                <>
                  <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={modalStyle}>
                      <Row>
                        <Col md={12}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginBottom: "2%",
                            }}
                          >
                            <h4>Enter Page Title</h4>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <TextField
                              className="muiTextInput"
                              id="outlined-basic"
                              onChange={handleTitleName}
                              placeholder="Page Title"
                              variant="outlined"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <div
                            style={{
                              marginTop: "4%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <button
                              onClick={handleShowTitle}
                              className="saveTitleBtn"
                            >
                              Save
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Box>
                  </Modal>
                  {/* <button onClick={handleOpenModal} className="addTitleBtn">
                  Add Title
                </button> */}
                  {/* <div className="addTitleBtn">Container Title</div> */}
                </>
              ) : (
                <p>{titleName}</p>
              )}
            </div>
          )}
          <div className={`removeMargin flex ${hide ? "hideComponent" : alignment === "top"
              ? "flex-col "
              : alignment === "left"
              ? "justify-between items-center gap-20"
              : "justify-end items-center gap-5 prevSpace"}`}>
          {/* <div className={` ${disabled ? "labelDisabled" : "labelContainer"}`}>
          <p>
            {label === "" ? (
              "Age Range Year"
            ) : (
              <span dangerouslySetInnerHTML={{ __html: sanitizedLabel }} />
            )}
          </p>
          </div> */}
          <Typography
              className={`custom-typography-class ${disabled ? "labelDisabled" : "labelContainer"}`}
              sx={{ mt: 4, mb: 2 }}
              variant="h6"
              component="div"
            >
              {label === "" ? (
              "Age Range Year"
            ) : (
              <p dangerouslySetInnerHTML={{ __html: sanitizedLabel }} />
            )}
            </Typography>
          <div className={`ageRangeInputBody flex gap-2 ${
              alignment === "top"
                ? ""
                : alignment === "left"
                ? "order-last"
                : ""
            }`}>
              <div>
            <div className="w-[462px]">
              <TextField
                className="muiTextInput size max-w-xl"
                id="outlined-basic"
                type="number"
                style={{
                  width: customWidth ? `${customWidth}px` : "230px",
                }}
                ref={ref}
                name={name}
                onChange={changeYear}
                value={value}
                placeholder="Age Year"
                variant="outlined"
                defaultValue={defaultValue}
                inputProps={{
                  "aria-label": "Without label",
                  className: "custom-text-class",
                }}
                
                InputProps={{
                  style: {
                    fontSize: textSize ? `${textSize}px` : "12px",
                  },
                }}
                disabled={disabled}
              />
            </div>
            {subLabel ? (
                <span className="text-[10px] ml-1">{subLabel}</span>
              ) : (
                ""
              )}
          </div>
          </div>
          </div>
        </div>
      )}
    </>
  );
});



export default AgeRangeYear;
